import { sidebarTabsKeys } from '../../../config';

const getSidebarPanelKey = name => sidebarTabsKeys.indexOf(name);

export default getSidebarPanelKey;
